export default ({ poweredBy = "", description = "" }) => {
	return {
		poweredBy,
		description,
	};
};
